import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { RouterModule } from '@angular/router';
import { QueryList } from '../../providers/query-list';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
//import { SearchAcctsComponent } from '../search-accts/search-accts.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-fixed-asset',
  templateUrl: './fixed-asset.component.html',
  styleUrls: ['./fixed-asset.component.css']
})
export class FixedAssetComponent implements OnInit {

  fixed_mainAcct = [];
  asset = [];
  acctList = [];
  acctDetail = '';

  model = {
    'table_name': 'fixed_asset', 'asset_id': '0', 'acct_number': '', 'main_acct_no': '', 'asset_name': '',
    'asset_name_en': '', 'asset_number': '', 'asset_desc': '', 'orginal_cost': '', 'start_date': '0000-00-00',
    'def_age': '', 'sale_scrap_cost': '', 'depr_percent': '', 'credit_acct_no': '', 'supplier_invoice_id': '0',
    'key': 'asset_id', 'flag': 'new', 'cost_center': this.applicationConstants.cost_center, 'comment': '', 'is_account': '0',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id
  };

  // base_model = {
  //   'table_name': 'acct_base', 'base_date': '', 'acct_number': '', 'main_acct_no': '', 'acct_type_no': '',
  //   'baseline_amount': '0', 'comment': ''
  // };

  // sub_acct_model = {
  //   'table_name': 'sub_acct', 'sub_acct_id': '0', 'acct_type_no': '2', 'main_acct_no': '201', 'sub_acct_name': '',
  //   'sub_acct_name_en': '', 'acct_number': '', 'tax_acct': '0', 'emp_no': '0', 'cc_no': '0',
  //   'key': 'sub_acct_id', 'flag': 'new', 'comment': '', 'auto_set': '0', 'set_type': 'count'
  // };



  sub_acct_model = {
    'table_name': 'sub_acct', 'acct_type_no': this.applicationConstants.acct_type_config['fixed_asset'],
    'main_acct_no': this.applicationConstants.main_acct_config['fixed_asset'], 'sub_acct_name': '',
    'sub_acct_name_en': '', 'acct_number': '', 'parent_acct': '', 'acct_level': '0', 'is_leaf': '1',
    'is_cc': '1', 'emp_no': '', 'key': 'sub_acct_id', 'flag': 'new', 'deletable': '1'
  };

  base_model = {
    'table_name': 'acct_base', 'baseline_id': '0', 'acct_number': '0',
    'main_acct_no': this.applicationConstants.main_acct_config['fixed_asset'],
    'acct_type_no': this.applicationConstants.acct_type_config['fixed_asset'], 'base_date': '',
    'key': 'baseline_id', 'flag': 'new', 'baseline_amount': '0'
  };

  date_model = { 'start_date': new Date(this.applicationConstants.business_cycle.start_date), 
    'enable_main': false };
  from_acct = { sub_acct_name: "", sub_acct_name_en: "", sub_acct_id: '0', acct_number: '', mobile: '' };
  //acctDialogRef: MatDialogRef<SearchAcctsComponent>;

  search_obj = {
    'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
    'table_list': [
      {
        'table_name': '`sub_acct`', 'selected_no': 'acct_number',
        'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en'],
        'condition': " AND `is_leaf` = '1' AND `is_cc` = '1'"
      }
    ]
  };

  // {
  //   'table_name': '`customer`', 'selected_no': 'acct_number',
  //   'field_list': ['acct_number', 'customer_name', 'customer_name_en']
  // },
  // {
  //   'table_name': '`supplier`', 'selected_no': 'acct_number',
  //   'field_list': ['acct_number', 'supplier_name', 'supplier_name_en']
  // },
  // {
  //   'table_name': '`bank_account`', 'selected_no': 'acct_number',
  //   'field_list': ['acct_number', 'bank_acct_number', 'account_name', 'account_name_en']
  // },

  Acct_Placeholder; Success_Msg; Error_Msg; Acct_Msg; Main_Acct_Msg;
  Asset_No_Msg; Name_Msg; Org_Cost_Msg; Def_Age_Msg; Scrap_Cost_Msg;
  Depr_Percent_Msg; Belong_To_Msg; Acct_No_Msg; Acct_No_Exist;
  Asset_Exist_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants, private queryList: QueryList,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    private dialogRef: MatDialogRef<FixedAssetComponent>, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Acct_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Acct_Msg').subscribe((res: string) => {
      this.Acct_Msg = res;
    });

    translate.get('Main_Acct_Msg').subscribe((res: string) => {
      this.Main_Acct_Msg = res;
    });

    translate.get('Asset_No_Msg').subscribe((res: string) => {
      this.Asset_No_Msg = res;
    });

    translate.get('Name_Msg').subscribe((res: string) => {
      this.Name_Msg = res;
    });

    translate.get('Org_Cost_Msg').subscribe((res: string) => {
      this.Org_Cost_Msg = res;
    });

    translate.get('Def_Age_Msg').subscribe((res: string) => {
      this.Def_Age_Msg = res;
    });

    translate.get('Scrap_Cost_Msg').subscribe((res: string) => {
      this.Scrap_Cost_Msg = res;
    });

    translate.get('Depr_Percent_Msg').subscribe((res: string) => {
      this.Depr_Percent_Msg = res;
    });

    translate.get('Belong_To_Msg').subscribe((res: string) => {
      this.Belong_To_Msg = res;
    });

    translate.get('Acct_No_Msg').subscribe((res: string) => {
      this.Acct_No_Msg = res;
    });

    translate.get('Acct_No_Exist').subscribe((res: string) => {
      this.Acct_No_Exist = res;
    });

    translate.get('Asset_Exist_Msg').subscribe((res: string) => {
      this.Asset_Exist_Msg = res;
    });

  }

  ngOnInit() {

    let obj;

    // get not leaf cash accts
    let parent_acct = this.applicationConstants.main_acct_config['fixed_asset'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: false };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.acctList = data.data['list'];

        if (this.dialog_data == null) {
          if (this.acctList.length > 0) {
            parent_acct = this.acctList[0]['acct_number'];
            this.acctDetail = parent_acct + ' - ' + this.acctList[0]['sub_acct_name'] + ' - ' +
              this.acctList[0]['sub_acct_name_en'];
          }
          else
            this.acctDetail = parent_acct + ' - الأصول الثابتة - Fixed Assets';

          this.onChangeAcctSearch("", parent_acct);
        }
      });

    // let query = this.queryList.all_mainAcct + " AND `acct_type_no` = '2'";
    // let obj = { cmd: 'getList', query: query };

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.fixed_mainAcct = data.data['list'];
    //   });

    if (this.dialog_data != null) {
      if (this.dialog_data['sub_acct_id'] != undefined) {
        if (this.dialog_data['sub_acct_id'] == '0') {
          this.model['main_acct_no'] = this.dialog_data['main_acct_number'];
          this.date_model['enable_main'] = true;
        }
        else {
          this.model['main_acct_no'] = this.dialog_data['main_acct_number'];
          this.date_model['enable_main'] = true;
          let query = "SELECT * FROM `fixed_asset` WHERE `acct_number` = '"
            + this.dialog_data['acct_number'] + "' AND `status` = '1'";
          let obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              this.asset = data.data['list'];
              this.model = {
                'table_name': 'fixed_asset',
                'asset_id': this.asset['0']['asset_id'],
                'acct_number': this.asset['0']['acct_number'],
                'main_acct_no': this.asset['0']['main_acct_no'],
                'asset_name': this.asset['0']['asset_name'],
                'asset_name_en': this.asset['0']['asset_name_en'],
                'asset_number': this.asset['0']['asset_number'],
                'asset_desc': this.asset['0']['asset_desc'],
                'orginal_cost': this.asset['0']['orginal_cost'],
                'start_date': '0000-00-00',
                'def_age': this.asset['0']['def_age'],
                'sale_scrap_cost': this.asset['0']['sale_scrap_cost'],
                'depr_percent': this.asset['0']['depr_percent'],
                'credit_acct_no': this.asset['0']['credit_acct_no'],
                'supplier_invoice_id': this.asset['0']['supplier_invoice_id'],
                'key': 'asset_id', 'flag': 'update',
                'cost_center': this.asset['0']['cost_center'],
                'comment': this.asset['0']['comment'],
                'is_account': this.asset['0']['is_account'],
                'branch_id': this.asset['0']['branch_id']
              };
              this.date_model['start_date'] = new Date(this.asset['0']['start_date']);
              this.getAcctInfo(this.asset['0']['credit_acct_no']);



              if (this.model['acct_number'] != '') {
                query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
                obj = { cmd: 'getList', query: query };
                this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                  .subscribe(data => {
                    this.applicationConstants.appComp.hideBusyCursor();

                    if (data.data['list'].length > 0) {
                      let sub_acct = data.data['list'][0];
                      (document.getElementById('is_account') as HTMLInputElement).checked = true;
                      this.sub_acct_model['sub_acct_id'] = sub_acct['sub_acct_id'];
                      this.sub_acct_model['sub_acct_name'] = sub_acct['sub_acct_name'];
                      this.sub_acct_model['sub_acct_name_en'] = sub_acct['sub_acct_name_en'];
                      this.sub_acct_model['acct_number'] = sub_acct['acct_number'];
                      this.sub_acct_model['parent_acct'] = sub_acct['parent_acct'];
                      this.sub_acct_model['acct_level'] = sub_acct['acct_level'];
                      this.sub_acct_model['flag'] = 'update';

                      // get parent acct detail
                      query = this.queryList.all_subAcct + " AND `acct_number` = '" + sub_acct['parent_acct'] + "'";
                      obj = { cmd: 'getList', query: query };

                      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                        .subscribe(data => {
                          this.applicationConstants.appComp.hideBusyCursor();

                          let parent_acct = data.data['list'][0];
                          this.acctDetail = sub_acct['parent_acct'] + ' - ' + parent_acct['sub_acct_name'] + ' - ' +
                            parent_acct['sub_acct_name_en'];
                          // console.log(parent_acct);

                        });
                    }
                  });
              }

              //if the asset is account:
              // if (this.model['is_account'] == '1') {
              //   (document.getElementById('is_account') as HTMLInputElement).checked = true;
              //   this.sub_acct_model['sub_acct_name'] = this.model['asset_name'];
              //   this.sub_acct_model['sub_acct_name_en'] = this.model['asset_name_en'];
              //   this.sub_acct_model['acct_number'] = this.model['acct_number'];
              //   this.sub_acct_model['comment'] = this.model['comment'];
              //   this.sub_acct_model['flag'] = 'update';

              //   let query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "' AND `status` = '1'";
              //   let obj = { cmd: 'getList', query: query };
              //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              //     .subscribe(data => {
              //       this.applicationConstants.appComp.hideBusyCursor();
              //       let sub_acct = data.data['list'];
              //       this.sub_acct_model['sub_acct_id'] = sub_acct['0']['sub_acct_id'];
              //     });
              // }
            });

        }

      }
      else {
        this.getAcctInfo(this.dialog_data['credit_acct_no']);
        this.model = this.dialog_data;

        //if the asset is account:

        if (this.model['acct_number'] != '') {
          let query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "'";
          obj = { cmd: 'getList', query: query };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              if (data.data['list'].length > 0) {
                let sub_acct = data.data['list'][0];
                (document.getElementById('is_account') as HTMLInputElement).checked = true;
                this.sub_acct_model['sub_acct_id'] = sub_acct['sub_acct_id'];
                this.sub_acct_model['sub_acct_name'] = sub_acct['sub_acct_name'];
                this.sub_acct_model['sub_acct_name_en'] = sub_acct['sub_acct_name_en'];
                this.sub_acct_model['acct_number'] = sub_acct['acct_number'];
                this.sub_acct_model['parent_acct'] = sub_acct['parent_acct'];
                this.sub_acct_model['acct_level'] = sub_acct['acct_level'];
                this.sub_acct_model['flag'] = 'update';

                // get parent acct detail
                query = this.queryList.all_subAcct + " AND `acct_number` = '" + sub_acct['parent_acct'] + "'";
                obj = { cmd: 'getList', query: query };

                this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                  .subscribe(data => {
                    this.applicationConstants.appComp.hideBusyCursor();

                    let parent_acct = data.data['list'][0];
                    this.acctDetail = sub_acct['parent_acct'] + ' - ' + parent_acct['sub_acct_name'] + ' - ' +
                      parent_acct['sub_acct_name_en'];
                    // console.log(parent_acct);

                  });
              }
            });
        }


        // if (this.model['is_account'] == '1') {
        //   (document.getElementById('is_account') as HTMLInputElement).checked = true;
        //   this.sub_acct_model['sub_acct_name'] = this.model['asset_name'];
        //   this.sub_acct_model['sub_acct_name_en'] = this.model['asset_name_en'];
        //   this.sub_acct_model['acct_number'] = this.model['acct_number'];
        //   this.sub_acct_model['comment'] = this.model['comment'];
        //   this.sub_acct_model['flag'] = 'update';

        //   let query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.model['acct_number'] + "' AND `status` = '1'";
        //   let obj = { cmd: 'getList', query: query };
        //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        //     .subscribe(data => {
        //       this.applicationConstants.appComp.hideBusyCursor();
        //       let sub_acct = data.data['list'];
        //       this.sub_acct_model['sub_acct_id'] = sub_acct['0']['sub_acct_id'];
        //     });
        // }

        //console.log(this.model);
        //this.date_model = this.dialog_data['1'];
      }
    }

  }

  onChangeAcctSearch = function (acct_number: string, parent_acct: string) {
    console.log(acct_number);

    if (acct_number != '' || parent_acct != '') {
      this.sub_acct_model['parent_acct'] = "";
      this.sub_acct_model['acct_level'] = "0";

      if (acct_number != '')
        this.sub_acct_model['parent_acct'] = acct_number;
      else if (parent_acct != '')
        this.sub_acct_model['parent_acct'] = parent_acct;

      // if (this.sub_acct_model['parent_acct'] != "") {
      var element;
      for (let index = 0; index < this.acctList.length; index++) {
        element = this.acctList[index];
        if (element.acct_number == this.sub_acct_model['parent_acct']) {
          this.sub_acct_model['acct_level'] = String(Number(element.acct_level) + 1);
          break;
        }
      }
      if (this.sub_acct_model['acct_level'] == "0")
        this.sub_acct_model['acct_level'] = String(Number(this.sub_acct_model['acct_level']) + 1);

      if (this.model['asset_id'] == '0' || (this.model['asset_id'] != '0' && this.model['acct_number'] == '')) {
        this.sub_acct_model['acct_number'] = "";

        let query = "SELECT COALESCE(MAX(CAST(`acct_number` AS UNSIGNED)), 0) AS `acct_number` FROM `sub_acct` WHERE `parent_acct` = '" +
          this.sub_acct_model['parent_acct'] + "'";
        let obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();

            let result = Number(data.data['list'][0]['acct_number']);
            if (result == 0)
              this.sub_acct_model['acct_number'] = this.sub_acct_model['parent_acct'] + "001";
            else
              this.sub_acct_model['acct_number'] = String(result + 1);

          });
        // }
      }

    }
  }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);
    this.from_acct.acct_number = search_result['no'];

    if (this.from_acct.acct_number != '') {
      this.from_acct.sub_acct_name = (document.getElementById('search_value_0') as HTMLInputElement).value;
      let main_acct_no = (this.from_acct.acct_number).substring(0, 3);
      this.model['credit_acct_no'] = this.from_acct.acct_number;
      
      // console.log(this.from_acct.acct_number);
      if (main_acct_no == '103') {
        this.from_acct.account_type = 'customer';
      }
      else if (main_acct_no == '401') {
        this.from_acct.account_type = 'supplier';
      }
      else if (main_acct_no == '102')
        this.from_acct.account_type = 'bank';
      else
        this.from_acct.account_type = 'account';
    }
  }

  changeIsAccount() {
    this.model['is_account'] = ((document.getElementById('is_account') as HTMLInputElement).checked ? '1' : '0');
  }

  changeAcctNumber() {
    if (this.sub_acct_model['acct_number'] == "" && this.sub_acct_model['parent_acct'] != "")
      this.onChangeAcctSearch("", this.sub_acct_model['parent_acct']);
  }

  getAcctInfo(credit_acct_no) {
    // let acct_type = credit_acct_no.substring(0, 3);
    //console.log(acct_type);
    // let table, acct_no, acct_name;
    // if (acct_type == '103') {
    //   table = '`customer`';
    //   acct_no = 'customer_no';
    //   acct_name = 'customer_name';
    // }
    // else if (acct_type == '401') {
    //   table = '`supplier`';
    //   acct_no = 'supplier_no';
    //   acct_name = 'supplier_name';
    // }
    // else if (acct_type == '102') {
    //   table = '`bank_account`';
    //   acct_no = 'acct_number';
    //   acct_name = 'account_name';
    // }
    // else {
    //   table = '`sub_acct`';
    //   acct_no = 'acct_number';
    //   acct_name = 'sub_acct_name';
    // }
    // let subAccts = [];
    // let query = "SELECT * FROM " + table + " WHERE `status` = '1' AND `" + acct_no + "` = " + credit_acct_no;
    let query = "SELECT * FROM `sub_acct` WHERE `status` != '0' AND `acct_number` = '" + credit_acct_no + "'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        let subAccts = data.data['list'];
        if (subAccts.length != 0) {
          this.from_acct.sub_acct_name = subAccts['0']['sub_acct_name'];
          this.from_acct.acct_number = subAccts['0']['acct_number'];

          (document.getElementById('search_value_0') as HTMLInputElement).value =
            subAccts['0']['sub_acct_name'] + ' - ' + subAccts['0']['sub_acct_name_en'] + ' - ' + subAccts['0']['acct_number'];
          //this.from_acct.sub_acct_id = subAccts['0']['sub_acct_id'];
        }
      });

  }

  // searchAcct() {
  //   this.acctDialogRef = this.dialog.open(SearchAcctsComponent, {
  //     hasBackdrop: false,
  //     height: '500px',
  //     width: '600px',
  //     data: this.dialog_data
  //   });

  //   this.acctDialogRef
  //     .afterClosed()
  //     .subscribe(result => {
  //       if (result != undefined)
  //         this.from_acct = result;
  //       console.log(this.from_acct);
  //     });
  // }

  add() {
    // if (this.model['main_acct_no'] == '') {
    //   alert(this.Main_Acct_Msg);
    //   (document.getElementById('main_acct_no') as HTMLInputElement).focus();
    //   return;
    // }

    if (this.model['asset_number'] == '') {
      alert(this.Asset_No_Msg);
      (document.getElementById('asset_number') as HTMLInputElement).focus();
      return;
    }

    if (this.model['asset_name'] == '') {
      alert(this.Name_Msg);
      (document.getElementById('asset_name') as HTMLInputElement).focus();
      return;
    }
    // else if (this.model['asset_name_en'] == '') {
    //   alert("الرجاء إدخال الاسم الانجليزي");
    //   (document.getElementById('asset_name_en') as HTMLInputElement).focus();
    // }
    if (this.model['orginal_cost'] == '') {
      alert(this.Org_Cost_Msg);
      (document.getElementById('orginal_cost') as HTMLInputElement).focus();
      return;
    }

    if (this.model['def_age'] == '') {
      alert(this.Def_Age_Msg);
      (document.getElementById('def_age') as HTMLInputElement).focus();
      return;
    }

    if (this.model['sale_scrap_cost'] == '') {
      alert(this.Scrap_Cost_Msg);
      (document.getElementById('sale_scrap_cost') as HTMLInputElement).focus();
      return;
    }

    if (this.model['depr_percent'] == '') {
      alert(this.Depr_Percent_Msg);
      (document.getElementById('depr_percent') as HTMLInputElement).focus();
      return;
    }

    if (this.from_acct.acct_number == '') {
      alert(this.Acct_Msg);
      (document.getElementById('searchAcct') as HTMLInputElement).focus();
      return;
    }

    if (this.model['is_account'] == '1' && this.sub_acct_model['parent_acct'] == '') {
      alert(this.Belong_To_Msg);
      return;
    }

    if (this.model['is_account'] == '1' && this.sub_acct_model['acct_number'] == '') {
      alert(this.Acct_No_Msg);
      return;
    }

    let query, obj;

    if (this.model['asset_id'] == '0') {
      // check if asset number exists
      query = "SELECT * FROM `fixed_asset` WHERE `asset_number` = '" + this.model['asset_number'] + "'";
      obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          console.log(data.data['list'].length);

          //if asset number exist:
          if (data.data['list'].length > 0) {
            alert(this.Asset_Exist_Msg);
            (document.getElementById('asset_number') as HTMLInputElement).focus();
          }

          //if asset number does not exist:
          else {
            this.model['start_date'] = this.date_model['start_date'].getFullYear() + "-" +
              (this.date_model['start_date'].getMonth() + 1) + "-" + this.date_model['start_date'].getDate() +
              " 00:00:00";
            delete this.model['start_date_d'];
            this.model['credit_acct_no'] = this.from_acct.acct_number;

            if (this.model['is_account'] == '1')
              this.model['acct_number'] = this.sub_acct_model['acct_number'];

            let values = [];
            values.push(this.model);

            // this.model['acct_number'] = this.model['main_acct_no'];

            //if the asset is account:
            if (this.model['is_account'] == '1') {
              console.log(this.model['is_account']);
              query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.sub_acct_model['acct_number'] + "'";
              obj = { cmd: 'getList', query: query };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  let result = data.data['list'];
                  if (result.length > 0)
                    alert(this.Acct_No_Exist);

                  else {
                    //add acct base:
                    this.base_model['base_date'] = this.date_model['start_date'].getFullYear() + '-' +
                      (this.date_model['start_date'].getMonth() + 1) + '-' + this.date_model['start_date'].getDate() +
                      " 00:00:00";

                    // this.base_model['acct_number'] = this.model['main_acct_no'];
                    // this.base_model['main_acct_no'] = this.model['main_acct_no'];
                    // this.base_model['acct_type_no'] = '2';
                    // this.base_model['baseline_amount'] = this.model['orginal_cost'];
                    values.push(this.base_model);

                    //add sub acct:

                    this.sub_acct_model['sub_acct_name'] = this.model['asset_name'];
                    this.sub_acct_model['sub_acct_name_en'] = this.model['asset_name_en'];
                    // this.sub_acct_model['acct_number'] = this.model['acct_number'];
                    this.sub_acct_model['comment'] = this.model['comment'];

                    values.push(this.sub_acct_model);

                    obj = { cmd: 'add', values: values };

                    console.log(values);
                    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                      .subscribe(data => {
                        this.applicationConstants.appComp.hideBusyCursor();
                        if (data.status['type'] == 'success') {
                          alert(this.Success_Msg);
                          this.dialog_data = { 'op_type': 'success' };
                          this.dialogRef.close(this.dialog_data);
                        }
                        else {
                          alert(this.Error_Msg);
                        }
                      });
                  }
                });
            }

            else {
              obj = { cmd: 'add', values: values };
              console.log(values);

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.status['type'] == 'success') {
                    alert(this.Success_Msg);
                    this.dialog_data = { 'op_type': 'success' };
                    this.dialogRef.close(this.dialog_data);
                  }
                  else
                    alert(this.Error_Msg);
                });
            }
            // if (this.model['asset_id'] == '0') {
            //   let prefix = this.model['main_acct_no'];
            //   obj = { cmd: 'add', values: values, pk: 'acct_number', id: 'asset_id', main_table: 'fixed_asset', prefix: prefix };
            // }


          }
        });
    }

    else {
      // let where = [{ 'asset_id': this.model['asset_id'] }];
      // obj = { cmd: 'update', values: values, where: where };
      let values1 = [];
      values1.push(this.model);

      //if the supplier is account:
      if (this.model['is_account'] == '1') {
       
        if (this.model['acct_number'] == '') {

          query = "SELECT * FROM `sub_acct` WHERE `acct_number` = '" + this.sub_acct_model['acct_number'] + "'";
          obj = { cmd: 'getList', query: query };

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              let result = data.data['list'];
              if (result.length > 0)
                alert(this.Acct_No_Exist);

              else {
                //add acct base:
                this.base_model['base_date'] = this.date_model['start_date'].getFullYear() + '-' +
                  (this.date_model['start_date'].getMonth() + 1) + '-' + this.date_model['start_date'].getDate() +
                  " 00:00:00";
                this.base_model['flag'] = 'new';
                values1.push(this.base_model);

                //add sub acct:

                this.sub_acct_model['sub_acct_name'] = this.model['asset_name'];
                this.sub_acct_model['sub_acct_name_en'] = this.model['asset_name_en'];
                this.sub_acct_model['flag'] = 'new';
                this.sub_acct_model['comment'] = this.model['comment'];

                values1.push(this.sub_acct_model);

              }
            });
        }
        else {
          // add casher as sub acct
          this.sub_acct_model['sub_acct_name'] = this.model['asset_name'];
          this.sub_acct_model['sub_acct_name_en'] = this.model['asset_name_en'];
          this.sub_acct_model['acct_number'] = this.model['acct_number'];
          this.sub_acct_model['flag'] = 'update';

          values1.push(this.sub_acct_model);
        }

      }
      obj = { cmd: 'updateAdv', values: values1 };

      console.log(values1);

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else
            alert(this.Error_Msg);
        });
    }

  }


  cancel() {
    this.dialogRef.close(this.dialog_data);
    // if (this.acctDialogRef)
    //   this.acctDialogRef.close();
  }
}
